function isSecureContextForSw(): boolean {
  if (typeof window === "undefined") return false;
  if (window.isSecureContext) return true;
  return ["localhost", "127.0.0.1"].includes(window.location.hostname);
}

/** Имя `pwa-sw.js`: в dev webpack-dev-server отдаёт noop вместо `service-worker.js`. */
const SW_FILE = "pwa-sw.js";

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  if (!isSecureContextForSw()) {
    return;
  }

  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const swUrl = `${publicUrl}/${SW_FILE}`.replace(/^\/{2,}/, "/");

  navigator.serviceWorker
    .register(swUrl, { type: "classic", updateViaCache: "none" })
    .catch((error) => {
      console.error("Service worker registration failed:", error);
    });
}
